import React, { useState } from 'react'
import Programsdetails from '../components/Programs/Programsdetails'

const ProgramsdetailsLayout = () => {
    const rtl = false;

    const [toggled, setToggled] = useState(false);

    const handleToggleSidebar = (value) => {
        setToggled(value);
    };

    return (
        <>
            {/* <Aside
                  rtl={rtl}
                  toggled={toggled}
                  handleToggleSidebar={handleToggleSidebar}
              /> */}
            <Programsdetails handleToggleSidebar={handleToggleSidebar} />
        </>
    )
}

export default ProgramsdetailsLayout